import type { Payment } from '../../Types/invoice'
import { computed, toRef } from 'vue'

export function usePayment(payment: Payment | null) {
  const paymentRef = toRef<Payment | null>(payment)

  const hasRejectedReason = computed<boolean>(() => {
    return !!(paymentRef.value?.rejectedAt && paymentRef.value?.rejectMotif)
  })

  return {
    payment: paymentRef,
    hasRejectedReason,
  }
}
